import axios from 'axios'
var host = process.env.VUE_APP_API_HOST

export const userServices = {
  registerUser,
  refreshUser,
  loginUser,
  logoutUser,
  getLocalUser,
  requestNewPassword,
  saveNewPassword,
  updateLocalUser,
  createLocalUser,
  getClientList,
  getRegisteredEvents,
  getRegisteredArchivedEvents,
  getUserActivityMenu,
  getActivityDetail,
  setActivityComplete,
  getUsersForEvent,
  getTimeZones,
  postComment,
  deleteComment,
  getAlerts,
  acknowledgeAlert,
  deleteAlerts,
  getUserTelegram,
  createUserTelegram,
  updateUserTelegram,
  getHelpLinks,
  logUserAgent,
  getTemplatesForSale,
  getTemplateForSaleDetail,
  getTemplatePurchases,
  setEventArchived,
  setEventActive,
  reactToComment,
  showReactionsList,
  removeReactToComment,
  getEmailSuppressionList,
  removeEmailSuppression,
  uploadAvatarImage
}

function registerUser (user) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.registerUser: ' + user.email)
    axios.post(host + '/api/Authentication/createuser',
      {
        name: user.name,
        phone: user.phone,
        email: user.email,
        password: user.password,
        smsNotifications: user.smsNotifications,
        notificationMethod: user.notificationMethod,
        smsConsent: user.smsConsent
      })
      .then(response => {
        resolve(response.data)
      }, error => {
        console.log('Error Response: ' + error.response)
        reject(error)
      })
  })
}

function refreshUser (token, refreshToken) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.refreshUser')
    axios.post(host + '/api/Authentication/refresh',
      {
        token: token,
        refreshToken: refreshToken // not yet implemented
      })
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function loginUser (username, password) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.loginUser: ' + username)
    axios.post(host + '/api/Authentication/request',
      {
        username: username,
        password: password
      })
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function logoutUser (refreshToken) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.logoutUser')
    axios.post(host + '/api/Authentication/remove',
      {
        refreshToken
      })
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getLocalUser (email) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.getLocalUser: ' + email)
    axios
      .get(host + '/api/user/profile') // uses the claims token for email address
      .then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function requestNewPassword (email) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.requestNewPassword: ' + email)
    axios
      .post(host + '/api/Authentication/password/forgot', { email })
      .then(resp => {
        console.log('userServices.requestNewPassword: ' + JSON.stringify(resp))
        if (resp.response) {
          resolve(resp.response.data)
        } else {
          resolve(resp)
        }
      }, error => {
        reject(error)
      })
  })
}

function saveNewPassword (key, password) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.requestNewPassword: ' + key)
    axios
      .post(host + '/api/Authentication/password/save',
        {
          key: key,
          password: password
        })
      .then(resp => {
        console.log('userServices.requestNewPassword: ' + JSON.stringify(resp))
        if (resp.response) {
          resolve(resp.response.data)
        } else {
          resolve(resp)
        }
      }, error => {
        reject(error)
      })
  })
}

function updateLocalUser (user) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting userServices.updateLocalUser: ' + user.email)
    axios
      .put(host + '/api/user/', user) // uses the claims token for email address
      .then(response => {
        resolve(response.status)
      }, error => {
        reject(error)
      })
  })
}

function createLocalUser (user) {
  console.log('Attempting userServices.createLocalUser: ' + user)
  return new Promise(function (resolve, reject) {
    axios
      .post(host + '/api/user/',
        {
          name: user.name,
          phone: user.phone,
          email: user.email
        })
      .then(response => {
        console.log('userServices.crateLocalUser: ' + JSON.stringify(response))
        resolve(response.data)
      }, error => {
        reject(error)
      })
  })
}

function getClientList () {
  console.log('Attempting getClientList')
  return axios
    .get(host + '/api/user/event/client/list')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getRegisteredEvents () {
  console.log('Attempting getRegisteredEventsForUser')
  return axios
    .get(host + '/api/user/events/registered')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getRegisteredArchivedEvents () {
  console.log('Attempting getRegisteredEventsForUser')
  return axios
    .get(host + '/api/user/events/registered/archived')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getUserActivityMenu (eventId) {
  console.log('host: ' + host)
  return axios
    .get(host + '/api/user/event/' + eventId + '/activity/menu')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function setActivityComplete (eventId, activityId) {
  return new Promise(function (resolve, reject) {
    var activity = {
      ActivityId: activityId,
      EventId: eventId
    }
    console.log('Setting Activity Complete: ' + JSON.stringify(activity))
    return axios
      .post(host + '/api/user/event/activity/completed', activity)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Set Activity Complete Error: ' + activity)
        console.log(err)
        reject(err)
      })
  })
}

// Call to get the users Event Activity /event/x/activity/x
function getActivityDetail (eventId, activityId) {
  console.log('Attempting getActivityDetail')
  return axios
    .get(host + '/api/user/event/' + eventId + '/activity/' + activityId + '/detail')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getTimeZones () {
  console.log('Attempting getTimeZones')
  return axios
    .get(host + '/api/user/timezones')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getUsersForEvent (eventId) {
  console.log('Attempting getUsersForEvent')
  return axios
    .get(host + '/api/user/event/' + eventId + '/participants')
    .then(response => {
      response.data.forEach(element => {
        element.id = '@' + element.name.split(' ').join('').toLowerCase()
      })
      return response.data
    })
    .catch(err => {
      console.log(err)
      throw err
    })
}

function postComment (eventId, activityId, message, photos, tagged, parentId) {
  console.log('Event -> postComments')
  var comment = {
    activityId: activityId,
    eventId: eventId,
    message: message,
    tagged: tagged,
    photos: photos,
    parentId: parentId
  }
  console.log(JSON.stringify(comment))
  return axios
    .post(host + '/api/discussion', comment)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log(err)
      throw err
    })
}

function deleteComment (commentId) {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + '/api/discussion/' + commentId)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getAlerts (userid) {
  // console.log('Attempting getAlerts(' + userid + ')')
  return axios
    .get(host + '/api/alert/getuser/' + userid)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function acknowledgeAlert (id) {
  return new Promise(function (resolve, reject) {
    // delete doesn't really delete immediately
    return axios
      .delete(host + '/api/alert/' + id)
      .then(response => {
        resolve(true)
      })
      .catch(err => {
        console.log('Alert Delete Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function deleteAlerts () {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + '/api/alert/')
      .then(response => {
        resolve(true)
      })
      .catch(err => {
        console.log('Alert Delete Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function getUserTelegram () {
  console.log('Attempting getUserTelegram()')
  return axios
    .get(host + '/api/telegram/')
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function createUserTelegram (username, chatId) {
  console.log('Attempting getUserTelegram()')
  var telegram = {
    'id': '0',
    'userId': '',
    'username': username,
    'chatId': chatId
  }
  return axios
    .post(host + '/api/telegram/', telegram)
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function updateUserTelegram (telegram) {
  console.log('Attempting getUserTelegram()')
  return axios
    .put(host + '/api/telegram/', telegram)
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getHelpLinks (context) {
  console.log('Attempting getHelpLinks(\'' + context + '\')')
  return axios
    .get(host + '/api/help/', {
      params: {
        ctx: context
      }
    })
    .then(response => {
      // console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      if (err.response.status === 404) {
        return {}
      } else {
        throw err
      }
    })
}

function logUserAgent (agentString) {
  console.log('Attempting logUserAgent(\'' + agentString + '\')')
  return axios
    .post(host + '/api/help/agent', {
      'agent': agentString
    })
    .then(response => {
      return response.data
    })
    .catch(err => {
      return err
    })
}

function getTemplatesForSale (page, search) {
  console.log('Attempting getTemplatesForSale()')
  return axios
    .post(host + '/api/module/forsale/page/' + page, { criteria: search })
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function getTemplateForSaleDetail (id) {
  console.log('Attempting getTemplateForSaleDetail()')
  return axios
    .get(host + '/api/module/forsale/' + id)
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function getTemplatePurchases (id) {
  console.log('Attempting getTemplatePurchases()')
  return axios
    .get(host + '/api/client/module/purchases')
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function setEventArchived (id) {
  console.log('Attempting setEventArchived()')
  return axios
    .put(host + '/api/user/event/' + id + '/archive')
    .then(response => {
      // console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function setEventActive (id) {
  console.log('Attempting setEventArchived()')
  return axios
    .put(host + '/api/user/event/' + id + '/active')
    .then(response => {
      // console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function reactToComment (reaction) {
  console.log('Attempting reactToComment()')
  return axios
    .post(host + '/api/discussion/reaction', reaction)
    .then(response => {
      // console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function removeReactToComment (id) {
  console.log('Attempting removeReactToComment()')
  return axios
    .delete(host + '/api/discussion/' + id + '/reaction')
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function showReactionsList (id) {
  console.log('Attempting showReactionsList()')
  return axios
    .get(host + '/api/discussion/' + id + '/reactions')
    .then(response => {
      // console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function getEmailSuppressionList () {
  console.log('Attempting getEmailSupressionList()')
  return axios
    .get(host + '/api/user/suppressions')
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function removeEmailSuppression () {
  console.log('Attempting removeEmailSuppression()')
  return axios
    .delete(host + '/api/user/suppressions')
    .then(response => {
      console.log('Response: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      throw err
    })
}

function uploadAvatarImage (formData) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + `/api/user/avatar/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        return resolve(response)
      })
      .catch(err => {
        reject(err.response)
      })
  })
}
